module.exports = __webpack_public_path__ + "static/media/mail.02087385.svg";